export default __webpack_public_path__ + "static/media/Formato_Trayectoria_invitacionpublica.2142d602.docx";